import { buildURL } from 'react-imgix'

export const optimizedLogoUri = buildURL('https://triptcip.imgix.net/web-assets/logo.png', {
  quality: 50,
  width: 100
})
